import { useState } from 'react';
import { useDevLogin } from './useSession.js';

/** The development sign-in every app's card offers when `/auth/mode` says `devLogin`. */
export function DevSignInForm({ placeholder }: { placeholder: string }): React.JSX.Element {
  const devLogin = useDevLogin();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  return (
    <form
      className="signin-dev"
      onSubmit={(event) => {
        event.preventDefault();
        devLogin.mutate({ email, name: name === '' ? email : name });
      }}
    >
      <p className="subtle">Development sign-in</p>
      <input
        type="email"
        required
        placeholder={placeholder}
        value={email}
        onChange={(event) => setEmail(event.target.value)}
      />
      <input
        type="text"
        placeholder="Your name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
      <button className="button" type="submit" disabled={devLogin.isPending}>
        Sign in
      </button>
      {devLogin.isError && <p className="signin-error">{devLogin.error.message}</p>}
    </form>
  );
}
